import React from 'react';
import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import DosenButton from '../../../../../components/ui/Buttons/DosenButton';

interface Props {
  openDelete: boolean;
  setOpenDelete: any;
  deleteLoader: boolean;
  handeleDeleteMatch: any;
}

const MatchDeleteDialog = ({ openDelete, setOpenDelete, deleteLoader, handeleDeleteMatch }: Props) => {
  return ( 
    <Dialog
      open={openDelete}
      onClose={() => setOpenDelete(false)}
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: '#1C1C1C',
          backgroundImage: 'none',
          color: '#FDFDFD',
          border: '1px solid #2A2A2A',
          borderRadius: '12px'
        }
      }}
    >
      <CommonModalHeader 
        title={`Remove match`}
        handleCloseModal={() => setOpenDelete(false)}
      />
      <DialogContent>
        <Typography sx={{ fontSize: 14, lineHeight: '22px', color: '#B6B6B6' }}>
          Are you sure you want to remove this match?
        </Typography>
      </DialogContent>
      <DialogActions>
        <DosenButton
          fullWidth
          tone="basic"
          onClick={() => setOpenDelete(false)}
          sx={{ height: '48px !important', fontSize: '14px', fontWeight: 700 }}
        >
          Cancel
        </DosenButton>
        <DosenButton
          fullWidth
          loading={deleteLoader}
          loadingText="Removing..."
          onClick={handeleDeleteMatch}
          sx={{ height: '48px !important', fontSize: '14px', fontWeight: 700 }}
        >
          Remove Match
        </DosenButton>
      </DialogActions>
    </Dialog>
  );
};

export default MatchDeleteDialog;
